/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import PropTypes from 'prop-types'
import RichTextRenderer from '../../RichTextRenderer'
import { gameSummaryContainerStyle, gameSummaryTitleStyle } from '../styles'

const gameSummaryTitleRichTextStyle = css`
  .rich-text-content {
    font-family: inherit;
    font-size: inherit;
    font-weight: normal;
    line-height: inherit;
    letter-spacing: inherit;
    color: inherit;
  }

  .rich-text-content p,
  .rich-text-content h1,
  .rich-text-content h2,
  .rich-text-content h3,
  .rich-text-content a {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    color: inherit;
  }
`

/**
 * GameSummary component for displaying the game summary below the video
 * @param {Object} props - Component props
 * @param {Object} props.summary - Summary data
 * @returns {JSX.Element} GameSummary component
 */
const GameSummary = ({ summary }) => {
  if (!summary) {
    return null
  }

  return (
    <div css={gameSummaryContainerStyle}>
      <div css={[gameSummaryTitleStyle, gameSummaryTitleRichTextStyle]}>
        <RichTextRenderer content={summary.title} showReadMore={false} />
      </div>
      <RichTextRenderer
        content={summary.content}
        truncateLength={10000}
        showReadMore={true}
        readMoreAlign='center'
      />
    </div>
  )
}

GameSummary.propTypes = {
  summary: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }),
}

GameSummary.defaultProps = {
  summary: null,
}

export default GameSummary
